import {
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Button,
	Heading,
	Text,
} from '@chakra-ui/react';

import Preview from '@/components/Preview/Preview';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

interface ISectionEmbedProps {
	url: string;
}

export default function SectionEmbed(props: ISectionEmbedProps) {
	const { t } = useTranslation();

	function handleCopyCode() {
		const code = `
		<iframe src="${
			props.url + '?hideInfo=true'
		}" width="100%" height="100%" style="border: none; min-height: 600px"></iframe>`;
		navigator.clipboard.writeText(code);
		toast.success(t('Copied to clipboard') as string);
	}

	return (
		<AccordionItem>
			<AccordionButton>
				<Text fontSize="md" fontWeight="500" as="span" flex="1" textAlign="left">
					{t('Embed the booking page on your website')}
				</Text>
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel pb={4} overflow="auto">
				<Box position="relative" px="20" h="48">
					<Preview>
						<Box display="grid" gridTemplateRows="1fr 3fr" h="100%">
							<Box
								background="gray.100"
								borderRadius="md"
								display="flex"
								justifyContent="center"
								alignItems="center"
								flexDir="column"
							>
								<Heading textAlign="center" mb="4">
									My amazing website
								</Heading>
							</Box>
							<Box background="gray.100" borderRadius="md">
								<Box minH="600px" margin="auto" w="70%" h="100%" as="iframe" src={props.url + '?hideInfo=true'} />
							</Box>
						</Box>
					</Preview>
				</Box>
				<Box textAlign="center" my="2" color="gray.700">
					<Text>{t('Insert the booking page directly into your website.')}</Text>
				</Box>

				<Box my="4" display="flex" justifyContent="center">
					<Button m="auto" colorScheme="primary" size="sm" onClick={handleCopyCode}>
						{t('Copy HTML code')}
					</Button>
				</Box>
			</AccordionPanel>
		</AccordionItem>
	);
}
